import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as EconomyWebsocket from './economy.websocket';

export function* newAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.newAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* updateAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.updateAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* respondAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.respondAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* respondAgreementUpdate(action: any): SagaIterator {
  try {
    EconomyWebsocket.respondAgreementUpdate(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* seenAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.seenAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* archiveAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.archiveAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* archiveAgreementUpdate(action: any): SagaIterator {
  try {
    EconomyWebsocket.archiveAgreementUpdate(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* endAgreement(action: any): SagaIterator {
  try {
    EconomyWebsocket.endAgreement(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* newPurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.newPurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* updatePurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.updatePurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* seenPurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.seenPurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* archivePurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.archivePurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* deletePurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.deletePurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* restorePurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.restorePurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* disputePurchase(action: any): SagaIterator {
  try {
    EconomyWebsocket.disputePurchase(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* newTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.newTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* updateTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.updateTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* seenTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.seenTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* archiveTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.archiveTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* deleteTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.deleteTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* restoreTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.restoreTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* disputeTransfer(action: any): SagaIterator {
  try {
    EconomyWebsocket.disputeTransfer(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* updateSettings(action: any): SagaIterator {
  try {
    EconomyWebsocket.updateSettings(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 



// WEBPACK FOOTER //
// ./src/services/economy/economy.saga.ts